module.exports = __webpack_public_path__ + "img/Rectangle 259.c910be3c.png";